
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { getTimeAgo } from '@/utils/format';
import Toast from '@/utils/toast';

const namespace: string = 'dashboard';

@Component
export default class DashboardInquiries extends Vue {
	@Action('fetchInquiryFormRequestById', { namespace: 'inquiryForm' }) private fetchInquiryFormRequestById!: (id: number) => Promise<void>;
	@Getter('getInquiriesSummary', { namespace }) private inquiriesSummary!: DashboardInquiriesSummary | null;

	/**
	 * Return a human-readable relative time string for when an inquiry was submitted
	 *
	 * @param {string} date
	 * @return {string}
	 */
	private getSubmittedAgo(date: string): string {
		return `${this.$t('orders.inquiries.submitted')} ${getTimeAgo(date)}`;
	}

	/**
	 * Fetch the full inquiry, set it as selected, then navigate to the inquiries page
	 *
	 * @param {number} id
	 * @return {Promise<void>}
	 */
	private async openInquiry(id: number): Promise<void> {
		try {
			await this.fetchInquiryFormRequestById(id);
			this.$router.push('/inquiries').catch(() => {});
		}
		catch (error) {
			Toast.error(this.$t('orders.inquiries.error_fetching_inquiry'));
		}
	}
}
